/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Tr_7_AInputs */

const en_tut_tr_7_a = /** @type {(inputs: Tut_Tr_7_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That room is locked, private, or full. Open the **Permintaan masuk ruang** panel, choose the room, and press **Minta akses** — the room owner will see your request. A knock expires by itself after five minutes.`)
};

const id_tut_tr_7_a = /** @type {(inputs: Tut_Tr_7_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang itu terkunci, privat, atau penuh. Buka panel **Permintaan masuk ruang**, pilih ruangnya, lalu tekan **Minta akses** — pemilik ruang akan melihat permintaan Anda. Permintaan berakhir sendiri setelah lima menit.`)
};

/**
* | output |
* | --- |
* | "That room is locked, private, or full. Open the **Permintaan masuk ruang** panel, choose the room, and press **Minta akses** — the room owner will see your r..." |
*
* @param {Tut_Tr_7_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_tr_7_a = /** @type {((inputs?: Tut_Tr_7_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Tr_7_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_tr_7_a(inputs)
	return en_tut_tr_7_a(inputs)
});